var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_28065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6349 0H7.34425C3.29266 0.0119099 0.0119048 3.29409 0 7.34743V40.6744C0.0228175 44.7268 3.31349 48 7.36508 48H40.6349C44.6865 48 47.9772 44.7268 48 40.6744V7.34743C47.9881 3.28615 44.6944 0 40.6349 0ZM33.9256 24.4759C33.8552 24.5742 33.7698 24.6595 33.6716 24.73L27.4494 30.9757C27.0595 31.3797 26.4157 31.3896 26.0129 30.9996C26.005 30.9916 25.997 30.9837 25.9891 30.9757C25.6131 30.5698 25.6131 29.9416 25.9891 29.5356L30.5179 25.0257H15.0466C14.4623 25.0257 13.9881 24.5513 13.9881 23.9667C13.9881 23.3822 14.4623 22.9078 15.0466 22.9078H30.5179L26.0099 18.4822C25.6339 18.0763 25.6339 17.449 26.0099 17.0421C26.4147 16.6412 27.0655 16.6412 27.4702 17.0421L33.6925 23.3941C33.7937 23.4804 33.874 23.5886 33.9256 23.7117C34.0288 23.9558 34.0288 24.2308 33.9256 24.4739V24.4759Z",
    fill: "url(#paint0_linear_6_28065)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_28065",
    x1: 0,
    y1: 24,
    x2: 48,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050D42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_28065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowImage);
export default __webpack_public_path__ + "static/media/arrowImage.4b691a86fa68456ff54fcb5f4fa0c250.svg";
export { ForwardRef as ReactComponent };